import React, { FunctionComponent } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';
import { useShareContext } from '../../context/ShareContext';
import { usePageMeta } from '../../hooks';
import { LinkButton } from './LinkButton';
import { useTranslation } from 'react-i18next';
import { ShareLabel } from './ShareLabel';

export type WhatsAppShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const WhatsAppShare: FunctionComponent<WhatsAppShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { isPreview } = usePageMeta();
  const { shareItems } = useShareContext();
  const { t } = useTranslation('common', { useSuspense: false });

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'whatsapp',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
  };

  const as = !isPreview ? 'a' : 'div';
  const href = !isPreview
    ? `https://wa.me/?text=${encodeURI(shareItems.whatsApp.message)}`
    : undefined;
  const handleClick = !isPreview ? trackClick : undefined;
  return (
    <LinkButton
      as={as}
      dataQa="whatsapp-btn"
      href={href}
      onClick={handleClick}
      className={`jg-btn jg-btn--whatsapp ${className}`}
    >
      <ShareLabel labelText={t('common.whatsApp')} />
    </LinkButton>
  );
};

export default withTrack(WhatsAppShare);
